"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var publishers = {
    AP: "aftenposten",
    ASK: "askoyvaeringen",
    BEDRIFT: "schibsted",
    BTI: "bt",
    BYN: "bygdanytt",
    DNB: "aftenposten",
    DP: "dinepenger",
    E24: "dinepenger",
    MPL: "aftenposten",
    SA: "stavangeraftenblad",
    SCH: "schibsted",
    STR: "strilen",
    VG: "vg",
    VNY: "vestnytt",
    RB24: "randaberg24",
    OP: "oyposten",
    BAREASANE: "bareasane",
    SVD: '',
    OMNI: '',
    WELLOBE: '',
    AB: '',
    VEKTKLUBB: ''
};
var publisherFromClientShortHandName = function (clientShortHandName) {
    return publishers[clientShortHandName];
};
exports.default = publisherFromClientShortHandName;
//# sourceMappingURL=publisherFromClientShortHandName.js.map